import React, { useState, useEffect } from "react";
import LinkCards from "../../components/LinkCards/index";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Box, Typography } from "@material-ui/core";
//Importing Components
import { OutlinedButton } from "../../components/Buttons";

//Importing assets
import GithubLogo from "../../assets/social-icons/github.svg";
import LinkedInLogo from "../../assets/social-icons/linkedin.svg";
import InstagramLogo from "../../assets/social-icons/instagram.svg";
import CodepenLogo from "../../assets/social-icons/Codepen.svg";
import BehanceLogo from "../../assets/social-icons/Behance.svg";
import Twitter from "../../assets/social-icons/twitter.svg";
import profile from "../../assets/branding-logos/profile pic.webp";
import {linkdata} from "../../pages/LinksPage/linksdata"

import style from "./style";
const useStyles = makeStyles(style);

const LinksPage = () => {
    const classes = useStyles();
    
    return (
        <Grid className="wrapper">
            <Grid className={classes.profileHeader}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px', border: '1px solid #5D5FFF', borderRadius: '50%' }}>
                    <img width={150} src={profile} data-aos="fade-in" alt="profile picture" />
                </div>
                <Grid>
                    <Typography variant="h2" data-aos="fade-in" className={classes.name}>
                        Devraj Chatribin
                    </Typography>
                    <Typography variant="h6" gutterBottom className={classes.bio} data-aos="fade-in">
                        Front-end Developer and UI/UX Designer, based in Goa, India.
                    </Typography>
                    <div className={classes.socials}>
                        <a href="https://github.com/DevrajDC" target="_blank" rel="noreferrer" className="hover-detect">
                            <img width="40px" height="40px" data-aos="zoom-in" data-aos-delay="300" data-aos-anchor-placement="bottom-bottom" src={GithubLogo} alt="Github" />
                        </a>
                        <a href="https://linkedin.com/in/devraj-chatribin" target="_blank" rel="noreferrer" className="hover-detect">
                            <img width="40px" height="40px" data-aos="zoom-in" data-aos-delay="400" data-aos-anchor-placement="bottom-bottom" src={LinkedInLogo} alt="LinkedIn" />
                        </a>
                        <a href="https://instagram.com/designfordev" target="_blank" rel="noreferrer" className="hover-detect">
                            <img width="40px" height="40px" data-aos="zoom-in" data-aos-delay="500" data-aos-anchor-placement="bottom-bottom" src={InstagramLogo} alt="Instgram" />
                        </a>
                        <a href="https://twitter.com/devrajchatribin" target="_blank" rel="noreferrer" className="hover-detect">
                            <img width="40px" height="40px" data-aos="zoom-in" data-aos-delay="600" data-aos-anchor-placement="bottom-bottom" src={Twitter} alt="Twitter" />
                        </a>
                        <a href="https://codepen.io/devrajdc/" target="_blank" rel="noreferrer" className="hover-detect">
                            <img width="40px" height="40px" data-aos="zoom-in" data-aos-delay="700" data-aos-anchor-placement="bottom-bottom" src={CodepenLogo} alt="Codepen" />
                        </a>
                        <a href="https://www.behance.net/devrajchatribin" target="_blank" rel="noreferrer" className="hover-detect">
                            <img width="40px" height="40px" data-aos="zoom-in" data-aos-delay="800" data-aos-anchor-placement="bottom-bottom" src={BehanceLogo} alt="Behance" />
                        </a>
                    </div>
                </Grid>
            </Grid>
            {
                linkdata.map((section, id) => {
                    return <Grid className={classes.content}>
                        <Typography variant="h2" className={classes.secondaryTitle} data-aos="fade-in">
                            {section.heading}
                        </Typography>
                        <Grid className={classes.cardsContainer}>
                            <LinkCards links={section.links}/>
                        </Grid>
                    </Grid>
                })
            }
        </Grid>
    );
};

export default LinksPage;
